import { Trans } from '@lingui/macro';
import React, { FC } from 'react';

import { TextP2 } from 'uikit/Text';
import { useCityDistricts } from 'utils/graphql/geolocation';

/**
 * For SEO purposes
 * see: https://naspersclassifieds.atlassian.net/browse/GS-8276
 */

type Props = {
  cityId: string;
  l4Name: string;
};

const L4CityDistrictsText: FC<Props> = (props) => {
  const { data } = useCityDistricts(props.cityId);

  if (!data || !data.cityDistricts.length) return null;

  const districts: string[] = data.cityDistricts.map((item) => item.name);

  return (
    <div className="container">
      <TextP2>
        <Trans>Na Fixly znajdziesz najlepszych specjalistów w kategorii {props.l4Name} w Twojej okolicy.</Trans>{' '}
        <Trans>Pracujemy w {districts.join(', ')}</Trans>
      </TextP2>
    </div>
  );
};

export default L4CityDistrictsText;
